<template>
  <div>
    <div v-for="(item, index) in menuItems" :key="index" class="mb-4">
      <!-- Top-level menu item -->
      <div 
        v-if="item.submenu"
        @click="toggleSubmenu(index)" 
        class="group flex items-center py-3 cursor-pointer"
        :class="isActiveMenuItem(item) ? 'text-white' : ''"
      >
        <icon 
          :name="item.icon" 
          class="mr-2 w-4 h-4" 
          :class="isActiveMenuItem(item) ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"
        />
        <div 
          class="flex-grow"
          :class="isActiveMenuItem(item) ? 'text-white' : 'text-indigo-300 group-hover:text-white'"
        >
          {{ item.label }}
        </div>
        <svg 
          class="w-4 h-4 transition-transform" 
          :class="openSubmenu === index ? 'rotate-180' : ''"
          fill="currentColor" 
          viewBox="0 0 20 20"
        >
          <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
        </svg>
      </div>

      <!-- Simple link for items without submenu -->
      <Link 
        v-else
        :href="item.href" 
        class="group flex items-center py-3"
        :class="isActiveMenuItem(item) ? ' text-white' : ''"
      >
        <icon 
          :name="item.icon" 
          class="mr-2 w-4 h-4" 
          :class="isActiveMenuItem(item) ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"
        />
        <div 
          :class="isActiveMenuItem(item) ? 'text-white' : 'text-indigo-300 group-hover:text-white'"
        >
          {{ item.label }}
        </div>
      </Link>

      <!-- Submenu -->
      <transition 
        enter-active-class="transition duration-200 ease-out"
        enter-from-class="opacity-0 -translate-y-2"
        enter-to-class="opacity-100 translate-y-0"
        leave-active-class="transition duration-200 ease-in"
        leave-from-class="opacity-100 translate-y-0"
        leave-to-class="opacity-0 -translate-y-2"
      >
        <div 
          v-if="item.submenu && openSubmenu === index" 
          class="pl-6 mt-2 space-y-2"
        >
          <Link 
            v-for="(subitem, subindex) in item.submenu" 
            :key="subindex"
            :href="subitem.href"
            class="block py-1"
            :class="isActiveMenuItem(subitem) 
              ? 'text-white ' 
              : 'text-indigo-300 hover:text-white'"
          >
            {{ subitem.label }}
          </Link>
        </div>
      </transition>
    </div>
  </div>
</template>


<script>
import { Link } from '@inertiajs/inertia-vue'
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,
    Link,
  },
  data() {
    return {
      openSubmenu: null,
      menuItems: [
        {
          label: 'Influencer',
          href: '/creator',
          icon: 'users',
          urlMatch: '/creator'
        },
        {
          label: 'Posts',
          href: '/post',
          icon: 'office',
          urlMatch: '/post'
        },
        {
          label: 'Facebook',
          icon: 'facebook',
          urlMatch: '/facebook',
          submenu: [
            {
              label: 'Campaigns',
              href: '/campaign',
              urlMatch: '/campaign'
            },
            {
              label: 'AdSets',
              href: '/adset',
              urlMatch: '/adset'
            },
            {
              label: 'Ads',
              href: '/ads',
              urlMatch: '/ads'
            },
          ]
        }
      ]
    }
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1);
      //console.log('in');
      if (urls[0] === '') {
        return currentUrl === '';
      }
      return urls.some(url => currentUrl.startsWith(url));
    },
    isActiveMenuItem(item) {
    const currentUrl = this.$page.url.split('?')[0]; // Get the path without query parameters

    // Check submenu items for active state
    if (item.submenu) {
    return item.submenu.some(subitem => {
      return currentUrl === subitem.urlMatch; // Match submenu item URLs
    });
    }

    // Match by urlMatch or href
    if (item.urlMatch) {
    return currentUrl === item.urlMatch; // Match the URL path without query parameters
    }

    return currentUrl === item.href; // Default matching for href
    },
    toggleSubmenu(index) {
      this.openSubmenu = this.openSubmenu === index ? null : index;
    }
  }
}
</script>

<style scoped>
.text-white{
  color: white;
}
</style>
